export const nextPrevVideoVariants = {
    selectedExit: {
        transform: [null, "scale3d(0.99, 0.99, 1)"],
        transition: {
            duration: 1,
            ease: "ease"
        }
    }
}